module.exports = __webpack_public_path__ + "media/images/hono32-7f16393dd81f84c36cb399c4d95d6594.ico";